import * as React from 'react'
import ClaimHeader from '../CodeClaimPage/components/ClaimHeader'
import { ClaimFooter } from '../components/ClaimFooter'
import WebsiteNameForm from './WebsiteNameForm'
import { RouteComponentProps } from 'react-router'

const WebsiteNamePage: React.FC<RouteComponentProps> = ({ history }) => {
  const handleOnSubmit = (name: string) => {
    history.push(`/claim-websites/${name}`)
  }

  return (
    <div className={'code-claim-page website-claim-page-container'}>
      <ClaimHeader title="" image="" originalImage="" claimed={false} showEventInfo={false} />
      <WebsiteNameForm onSubmit={handleOnSubmit} />
      <ClaimFooter />
    </div>
  )
}

export default WebsiteNamePage
